const language = {
    title: "",
    subtitle: "",
    email: "info@axelwens.be",
    phone: "+32 474 06 09 06"
};

export default language;